import React from 'react';

interface StrategyBadgeProps {
  positionType?: string | null;  // 'covered_call' | 'cash_secured_put'
  /** Slightly smaller variant for dense table rows. */
  compact?: boolean;
}

/**
 * CC / CSP tag (trader theme, Oct 2026): a quiet outlined label, the same as
 * the positions list. Single source of truth for the Performance and
 * Composition tables. Styled by `.strategy-badge` in trader-theme.css.
 */
const StrategyBadge: React.FC<StrategyBadgeProps> = ({ positionType, compact }) => {
  const isCsp = positionType === 'cash_secured_put';
  return (
    <span className={`strategy-badge ${compact ? 'is-compact' : ''}`} title={isCsp ? 'Cash-Secured Put' : 'Covered Call'}>
      {isCsp ? 'CSP' : 'CC'}
    </span>
  );
};

export default StrategyBadge;
